import React from 'react';
import { getFileName } from './ImageUploadBox';

interface ImageInfoProps {
  readonly url: string | undefined;
  readonly dimension?: string;
  readonly align?: 'left' | 'center';
}

export const ImageInfo: React.FC<ImageInfoProps> = ({ url, dimension }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      width: '100%',
      alignItems: 'center',
    }}
  >
    {dimension && (
      <div style={{ fontSize: '0.65rem', color: '#0d6efd', fontWeight: 500, textAlign: 'center' }}>{dimension}</div>
    )}
    <div
      style={{
        fontSize: '0.7rem',
        color: '#6c757d',
        wordBreak: 'break-all',
        width: '100%',
        textAlign: 'center',
      }}
      title={url}
    >
      {url ? getFileName(url) : 'No image selected'}
    </div>
  </div>
);
